
/*
window.addEventListener("scroll", () => {
  const currentScroll = window.pageYOffset;
  console.log('currentscroll: '+currentScroll);
  if (currentScroll <= checkpoint) {
    opacity = 1 - currentScroll / checkpoint;
    console.log('opacity: '+opacity);
  } else {
    opacity = 0;
  }
  document.querySelector(".standard-1-img-front").style.opacity = opacity;
});*/
var iframe1 = document.querySelector('#video-1-lg');
var player1 = new Vimeo.Player(iframe1);
const playbtn1 = document.getElementById('playbtn-1');


playbtn1.onclick = function() {
  playbtn1.style.display = "none";
  player1.play();
}

var iframe2 = document.querySelector('#video-1-md');
var player2 = new Vimeo.Player(iframe2);
const playbtn2 = document.getElementById('playbtn-2');


playbtn2.onclick = function() {
  playbtn2.style.display = "none";
  player2.play();
}
  
document.addEventListener( 'DOMContentLoaded', function () {
  new Splide( '#shop-gloves-slider', {
        padding     : { right: '50%' },
        type        : 'loop',
        mediaQuery  : 'min',
        breakpoints : {
            993: {
                destroy: true,
            },
      },
    }).mount();
});